import React, { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle2, XCircle, Loader2 } from "lucide-react";
import { api, formatApiErrorDetail } from "@/lib/api";

const Shell = ({ icon, title, children, testid }) => (
  <section className="py-28 bg-white dark:bg-navy-900" data-testid={testid}>
    <div className="max-w-xl mx-auto px-6 text-center">
      {icon}
      <h1 className="mt-6 font-serif text-4xl font-semibold text-navy-900 dark:text-white">{title}</h1>
      <div className="mt-4 text-slate-600 dark:text-slate-300">{children}</div>
      <Link to="/pricing" className="mt-10 inline-flex rounded-full border border-gold-500 px-6 py-3 font-semibold text-navy-900 dark:text-white hover:bg-gold-500/10" data-testid="billing-back-to-pricing">
        Back to plans
      </Link>
    </div>
  </section>
);

export function BillingSuccess() {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const [state, setState] = useState({ loading: true });

  useEffect(() => {
    if (!sessionId) {
      setState({ error: "Missing checkout reference." });
      return;
    }
    api
      .get(`/billing/session/${sessionId}`)
      .then(({ data }) => setState({ data }))
      .catch((e) => setState({ error: formatApiErrorDetail(e.response?.data?.detail) }));
  }, [sessionId]);

  if (state.loading)
    return <Shell testid="billing-success-page" icon={<Loader2 className="mx-auto h-10 w-10 animate-spin text-gold-500" />} title="Confirming your subscription" />;
  if (state.error)
    return <Shell testid="billing-success-page" icon={<XCircle className="mx-auto h-12 w-12 text-red-500" />} title="We couldn't confirm checkout"><p data-testid="billing-success-error">{state.error}</p></Shell>;
  const done = state.data.status === "complete";
  return (
    <Shell testid="billing-success-page" icon={<CheckCircle2 className="mx-auto h-12 w-12 text-gold-500" />} title={done ? "Subscription confirmed" : "Checkout in progress"}>
      <p data-testid="billing-success-plan">
        {done
          ? `Thank you — your ${state.data.plan_name} plan is set up. A receipt is on its way from Stripe.`
          : `Your ${state.data.plan_name} checkout has not completed yet.`}
      </p>
    </Shell>
  );
}

export function BillingCancel() {
  return (
    <Shell testid="billing-cancel-page" icon={<XCircle className="mx-auto h-12 w-12 text-slate-400" />} title="Checkout cancelled">
      <p>No payment was taken. You can choose a plan again whenever you're ready.</p>
    </Shell>
  );
}
